import { Injectable } from '@angular/core';
import { Cage } from '../interfaces/cage';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CageCrudService {
  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/cages/' ;
  }

  getOrganisation() : string | null {
    const company = JSON.parse(localStorage.getItem('company')!);
    if (company && typeof company.$key !== 'undefined') {
        return company.$key;
    }
    return null;
  }

  // Create Cage
  add(record: Cage) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Cage Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Cages List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Cage Object
  update(record: Cage) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Cage>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Cage Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}